/**
 * Tabs.
 * @return {Object} public methods.
 */
const Tabs = (function () {
	var $tabs,
		$tabsHeaders,
		$tabsContents,
		width;

	function init() {
        if ($('.tabs').length === 0) return false;
		gatherDOMElements();
		setInitialState();
		addListeners();
	}

	function gatherDOMElements() {
		$tabs = $('body').find(".tabs");
		$tabsHeaders = $tabs.find(".tabs__header");
		$tabsContents = $tabs.find(".tabs__content");
		width = $(window).width();
	}

	function setInitialState() {
		// Hide all tab contents but the first
		$tabsContents.not(":first").hide();
		// delete tabs__header-nojs and add tabs__header
		$tabsHeaders.removeClass('tabs__header');
		$tabsHeaders.addClass('tabs__header-js');
		if ($(window).width() >= 688) {
			// show first tab Header
			$($tabsHeaders[0]).show();
			// Move tab headers next to each other
			var headerOffsetLeft = 0;
			var headerPadding = 3;
			for (var i = 0; i < $tabsHeaders.length; i++) {
				$tabsHeaders[i].style.zIndex = $tabsHeaders.length - i;
				$tabsHeaders[i].style.marginLeft = headerOffsetLeft + "px";
				headerOffsetLeft += $tabsHeaders[i].offsetWidth + headerPadding;
			}

			if (!$tabsHeaders.is(".is-active")) {
				// Highlight the first tab header
				highlightTabHeader($tabsHeaders.first());
			}
		}
		else {
			// hide first tab Header
			$($tabsHeaders[0]).hide();
			// Reset tab headers to default position
			for (var j = 0; j < $tabsHeaders.length; j++) {
				$tabsHeaders[j].style.zIndex = 0;
				$tabsHeaders[j].style.marginLeft = 0;
			}
		}
	}

	function addListeners() {
		$tabsHeaders.on("click", onTabsHeaderClick);
		$(window).resize(onWindowResize);
	}

	function onWindowResize(e) {
		if($(window).width() == width) return false;
		setInitialState();
	}

	function onTabsHeaderClick(e) {
		var $tabsHeader = $(this);

		// It's already active so return right away
		if ($tabsHeader.hasClass("is-active")) {
			if ($(window).width() < 688){
				$tabsHeader.next(".tabs__content").hide();
				$tabsHeader.removeClass("is-active");
				$tabsHeader.html($tabsHeader.text());
                $(document).trigger( "tab:clicked" );
            }
			return false;
		}

		// Show clicked content
		if ($(window).width() >= 688) {
			$tabsContents.filter(":visible").hide();
		}
		$tabsHeader.next(".tabs__content").show();

		if (!matchMedia('only screen and (max-width: 705px)').matches) {
			// Unhighlight previous header
			unhighlightTabHeader($tabs.find(".tabs__header-js.is-active"));
		}

		// Highlight clicked header
		highlightTabHeader($tabsHeader);

		//trigger clicked event
		$(document).trigger( "tab:clicked" );

		return false;
	}

	function highlightTabHeader($tabsHeader) {
		var tabsHeaderText = $tabsHeader.text();

		$tabsHeader.addClass("is-active");
		$tabsHeader.html(tabsHeaderText);
	}

	function unhighlightTabHeader($tabsHeader) {
		$tabsHeader.removeClass("is-active");
		$tabsHeader.html($tabsHeader.text());
	}

	// Return public methods
	return {
		init: init
	};

})();

window.Tabs = Tabs;
export default Tabs;
